import { RAN_DB_UPDATE_SITE } from '../../../common/constants/constants';
import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const formUploadRanDb = async (form, id) => {
  try {
    const response = await apiClient.put(RAN_DB_UPDATE_SITE(id), form);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};
